module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "education"
  }, [_c('h3', [_vm._v("Education")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "university"
  }, [_c('a', {
    attrs: {
      "href": "https://www.usc.edu/",
      "target": "_blank"
    }
  }, [_vm._v("University of Southern California")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("2012 — 2014")])]), _vm._v(" "), _c('div', {
    staticClass: "college"
  }, [_vm._v("Master of Science in Computer Science")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "university"
  }, [_c('a', {
    attrs: {
      "href": "http://www.vit.ac.in/",
      "target": "_blank"
    }
  }, [_vm._v("VIT University")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v("2008 — 2012")])]), _vm._v(" "), _c('div', {
    staticClass: "college"
  }, [_vm._v("Bachelor of Technology in Computer Science & Eng.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d8d2f70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Education.vue
// module id = 51
// module chunks = 0